const turnoverData = [
  { year: '2017-2018', value: 57981234 },
  { year: '2018-2019', value: 68765349 },
  { year: '2019-2020', value: 32148726 },
  { year: '2020-2021', value: 39487654 },
  { year: '2021-2022', value: 38685367 },
  { year: '2022-2023', value: 48465788 },
  { year: '2023-2024', value: 49822130 },
  { year: '2024-2025', value: 57748718 },
  { year: '2025-2026', value: 70000000, expected: true },
];

export default turnoverData;
